import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "../layout/Page";
import axios from "axios";

// const data = [
//   {
//     contentType: "BLOG",
//     title: "Complimenting Fleet Modernization with Road Safety",
//     link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
//     linkText: "Read article",
//     thumbnail:
//       "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
//   },
//   {
//     contentType: "BLOG",
//     title: "Envisioning the Future of Mobility with Shoora",
//     description:
//       "Moving into a new world of software-defined, service-driven digital mobility.",
//     thumbnail:
//       "/images/thumbnails/14.jpeg",
//       link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
//   },
//   {
//     contentType: "BLOG",
//     title:
//       "Leverage AIS-140’s Mandate for Telematics Devices",
//     description:
//       "Moving into a new world of software-defined, service-driven digital mobility.",
//     thumbnail:
//       "https://www.easyembedded.net/images/ais2.jpg",
//       link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
//   },
//   {
//     contentType: "BLOG",
//   title: "Tackling Distracted Driving: Transforming Fleet Safety",
//   description:
//     "Moving into a new world of software-defined, service-driven digital mobility.",
//     thumbnail:
//     "/images/thumbnails/3.jpeg",
//     link: "/insights/blog/tackling-distracted-driving-transforming-fleet-safety",
//   },
//   {
//     contentType: "BLOG",
//     title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
//     description:
//         "Moving into a new world of software-defined, service-driven digital mobility.",
//     thumbnail:
//     "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
//     link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
//   },
//   {
//     contentType: "CUSTOMER STORY",
//     title:
//       "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
//     description:
//       "Moving into a new world of software-defined, service-driven digital mobility.",
//     thumbnail:
//     "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
//     link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
//   },

//   {
//     contentType: 'CUSTOMER STORY',
//     title: 'Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres',
//     description: 'Moving into a new world of software-defined, service-driven digital mobility.',
//     thumbnail:
//     "/images/thumbnails/15.jpeg",
//     link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
//   },

// ];

const Insights = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(8);
  const [data, setData] = useState(null);
  const [filters, setFilters] = useState({
    category: [],
    industry: [],
    solution: [],
  });

  const filterOptions = {
    category: [
      "Fleet Management",
      "Telematics",
      "Safety & Security",
      "Team Management",
      "Vehicle & Equipment Management",
      "Transportation & Logistics",
      "Public Transportation",
      "CSR",
    ],
    industry: [
      "Logistics",
      "Healthcare",
      "Retail",
      "Government",
      "Electric Vehicles",
      "Safety Solutions",
      "Construction & Heavy Equipment",
      "Oil & Gas",
    ],
    solution: [
      "Cabin Vision",
      "Road Sense",
      "Cabin Alerts",
      "Fleet Sense",
      "Marut Insights",
      "Life Savers"
    ],
  };

  const handleCheckboxChange = (filterType, value) => {
    setFilters((prev) => {
      const updatedFilters = prev[filterType].includes(value)
        ? prev[filterType].filter((item) => item !== value) // Remove if already selected
        : [...prev[filterType], value]; // Add new selection

      return { ...prev, [filterType]: updatedFilters };
    });
  };

  const fetchInsights = async () => {
    console.log("Fetching data with filters: ", filters);
    try {
      const res = await axios.post(
        `${
          import.meta.env.VITE_API_BASE_URL
        }/api/insights?limit=${limit}&page=${page}`,
        { filters }
      );
      if (res.status === 200) {
        console.log("Insights Data: ", res?.data);
        setData(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchInsights();
  }, [page, limit, filters]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Page
      title="Insights | Shoora"
      description="Discover the latest insights, customer stories, and blog posts from Shoora's innovative and transformative transportation technology solutions."
      keywords="shoora insights, customer stories, blog posts"
    >
      <div className="about-hero">
        <img
          src="https://www.datocms-assets.com/992/1729868262-ps-winter-ops-blog-adobestock_142097142.jpeg?w=690&h=460&fit=crop&auto=format&dpr=2"
          alt=""
          className="w-100"
          style={{ objectFit: "cover", overflow: "hidden" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div
            className="col col-12 col-lg-6 px-0 px-lg-5"
            style={{ backgroundColor: "" }}
          >
            <p className="fs-6 text-accent mt-5 fw-bold">Featured</p>
            <h1 className="text-light fw-bold mb-4">
              Envisioning the Future of Mobility with Shoora
            </h1>
            <p className="fs-5 text mb-5">
              Shoora offers comprehensive fleet management solutions that track
              vehicle locations, monitor driver performance, optimise routes,
              and reduce fuel consumption.
            </p>
            <div className="d-flex pb-5">
              <Link
                to="/insights/envisioning-the-future-of-mobility-with-shoora-213854"
                className="btn btn-dark rounded-5"
              >
                Read insight
              </Link>
              <Link className="ms-3 btn btn-link text-dark fw-bold text-decoration-none"></Link>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-dark">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Insights
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* <div className="container">
          <div className="row">
            <div className="col">
              <div class="dropdown w-100">
                <button
                  class="btn btn-light btn-filter dropdown-toggle w-100 rounded-0 p-3"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Filter By Categories
                </button>
                <ul class="dropdown-menu w-100 rounded-0">
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Business Management
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Compliance
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Safety & Security
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Team Management
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Vehicle & Equipment Management
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col">
              <div class="dropdown w-100">
                <button
                  class="btn btn-light btn-filter dropdown-toggle w-100 rounded-0 p-3"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Filter By Industries
                </button>
                <ul class="dropdown-menu w-100 rounded-0">
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Business Management
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Compliance
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Safety & Security
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Team Management
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Vehicle & Equipment Management
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col">
              <div class="dropdown w-100">
                <button
                  class="btn btn-light btn-filter dropdown-toggle w-100 rounded-0 p-3 text-left"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Filter By Solutions
                </button>
                <ul class="dropdown-menu w-100 rounded-0">
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Business Management
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Compliance
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Safety & Security
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Team Management
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check m-3">
                      <input
                        class="form-check-input rounded-0"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Vehicle & Equipment Management
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> */}

      <div className="container">
        <div className="row">
          {Object.keys(filterOptions)?.map((filterType) => (
            <div className="col" key={filterType}>
              <div className="dropdown w-100">
                <button
                  className="btn btn-light btn-filter dropdown-toggle w-100 rounded-0 p-3"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Filter By{" "}
                  {filterType.charAt(0).toUpperCase() + filterType.slice(1)}
                </button>
                <ul className="dropdown-menu w-100 rounded-0">
                  {filterOptions[filterType]?.map((option) => (
                    <li key={option}>
                      <div className="form-check m-3">
                        <input
                          className="form-check-input rounded-0"
                          type="checkbox"
                          value={option}
                          id={`${filterType}-${option}`}
                          checked={filters[filterType].includes(option)}
                          onChange={() =>
                            handleCheckboxChange(filterType, option)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`${filterType}-${option}`}
                        >
                          {option}
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="container" style={{ width: "100vw" }}>
        {data?.insights?.length ? (
          <>
            <div className="row row-cols-1 row-cols-md-4 row-gap-4">
              {data?.insights?.map((item) => (
                <div className="col">
                  <div className="resource-card">
                    <img src={item?.imgsrc} alt={item?.short} />
                    <div className="card-content">
                      <div className="resource-caption">
                        {item?.contentType}
                      </div>
                      <div className="resource-title">{item?.short}</div>
                      <div className="resource-action">
                        <Link
                          to={
                            (item?.slug && `/insights/${item?.slug}`) ||
                            item?.link ||
                            "#"
                          }
                        >
                          {item?.linkText ? item?.linkText : " Learn More "}{" "}
                          <i class="fa-solid fa-arrow-up-right-from-square"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="m-5">
              <nav
                aria-label="Page navigation d-flex justify-content-center"
                className="pagination-nav"
              >
                <ul class="pagination">
                  <li class="page-item">
                    <button
                      class="page-link"
                      aria-label="Previous"
                      disabled={page === 1}
                      onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                    >
                      <span aria-hidden="true">
                        <i class="fa-solid fa-chevron-left"></i>
                      </span>
                    </button>
                  </li>
                  <li class="page-item">
                    <a class="page-link" href="#">
                      {page}/{data?.total ? Math.ceil(data?.total / limit) : 1}
                    </a>
                  </li>
                  {/* <li class="page-item">
                  <a class="page-link" href="#">
                    2
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    3
                  </a>
                </li> */}
                  <li class="page-item">
                    <button
                      class="page-link"
                      aria-label="Next"
                      disabled={data?.insights?.length < limit}
                      onClick={() => setPage((prev) => prev + 1)}
                    >
                      <span aria-hidden="true">
                        <i class="fa-solid fa-chevron-right"></i>
                      </span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </>
        ) : (
          <>
            <div className="text-center">No results found.</div>
          </>
        )}
      </div>
    </Page>
  );
};

export default Insights;
